import { ImageToolbarProps } from './Types'
import { track } from '@tldraw/tldraw'
import { Toolbar } from '../ContextToolbar/Toolbar'
import { ImageShape } from 'components/VisualStudioPlayground/Shapes/ImageShape/Types'
import { CopyButton } from '../components/CopyButton/CopyButton'
import { DeleteButton } from '../components/DeleteButton/DeleteButton'
import { ReplaceButton } from './components/ReplaceButton'
import { BackgroundButton } from './components/BackgroundButton'
import { MoreOptionsButton } from '../components/MoreOptionsButton/MoreOptionsButton'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { FillCanvasButton } from './components/FillCanvasButton'

const ImageToolbar = track(({ editor, shapeId }: ImageToolbarProps) => {
  const shape = editor.getShape<ImageShape>(shapeId) as ImageShape
  const { isMobile } = useResponsiveDesign()

  return (
    <Toolbar>
      {!isMobile && <ReplaceButton editor={editor} selectedShape={shape} />}
      {!isMobile && <BackgroundButton editor={editor} selectedShape={shape} />}
      {!isMobile && <FillCanvasButton editor={editor} selectedShape={shape} />}
      <CopyButton withText={false} />
      <DeleteButton withText={false} />
      <MoreOptionsButton selectedShape={shape} />
    </Toolbar>
  )
})

export { ImageToolbar }
